import { render, staticRenderFns } from "./IncreaseByPercentagePopup.vue?vue&type=template&id=764f4be4"
import script from "./IncreaseByPercentagePopup.vue?vue&type=script&lang=ts"
export * from "./IncreaseByPercentagePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports